import { AxiosResponse } from 'axios';
import axiosInstance from '../utils/axios';
import amplifyConfig from '../config';
import API_PATH from './endpoints';
import type { CreateOrganizationBaseParams, DeleteOrganizationBaseParams, OrganizationBaseType, UpdateOrganizationBaseParams, UpdateOrganizationBaseParamsClient } from '../types/organizationBase';

const organizationAPI = {
  /**
   * 組織一覧の取得
   * @return OrganizationBaseType[]
   */
  getOrganizationBases: async () => {
    return axiosInstance.get<undefined, AxiosResponse<OrganizationBaseType[]>>(amplifyConfig.apiGateway.URL + API_PATH.ORGANIZATION_BASE.ORGANIZATION_BASE);
  },

  /**
   * 組織の作成
   * @param CreateOrganizationBaseParams
   * @return OrganizationBaseType
   */
  createOrganizationBase: async (params: CreateOrganizationBaseParams) => {
    return axiosInstance.post<CreateOrganizationBaseParams, AxiosResponse<OrganizationBaseType>>(amplifyConfig.apiGateway.URL + API_PATH.ORGANIZATION_BASE.ORGANIZATION_BASE, params);
  },

  /**
   * 組織の更新
   * @param UpdateOrganizationBaseParamsClient
   * @return OrganizationBaseType
   */
  updateOrganizationBase: async (params: UpdateOrganizationBaseParamsClient) => {
    const { id, organizationBaseName } = params;
    return axiosInstance.put<UpdateOrganizationBaseParams, AxiosResponse<OrganizationBaseType>>(amplifyConfig.apiGateway.URL + API_PATH.ORGANIZATION_BASE.ORGANIZATION_BASE + '/' + String(id), {
      organizationBaseName,
    });
  },

  /**
   * 組織の削除
   * @param DeleteOrganizationBaseParams
   * @return OrganizationBaseType
   */
  deleteOrganizationBase: async (params: DeleteOrganizationBaseParams) => {
    const { id } = params;
    return axiosInstance.delete<DeleteOrganizationBaseParams, AxiosResponse<OrganizationBaseType>>(amplifyConfig.apiGateway.URL + API_PATH.ORGANIZATION_BASE.ORGANIZATION_BASE + '/' + String(id));
  },
};

export default organizationAPI;
